import script from "./HomeMainText.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeMainText.vue?vue&type=script&setup=true&lang=js"

import "./HomeMainText.vue?vue&type=style&index=0&id=c7fbbb00&lang=css"
import "./HomeMainText.vue?vue&type=style&index=1&id=c7fbbb00&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c7fbbb00"]])

export default __exports__